module.exports = __webpack_public_path__ + "static/img/bg-id.649b1c90.png";